import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { truncate } from 'utils/string-utils';
import { PATH_CLIENT_EDIT } from 'routing/path'
import PageHeader from 'components/page-header'
import ClientMeasurementReportSearchFilter from 'components/search-filters/client-measurement-report-search-filter'
import Table from 'components/table'
import { useGetMeasurementReportsQuery, useDownloadMeasurementReportsMutation } from 'actions/client/client-dosemeter-measurement-api';
import { translationApi  } from 'actions/translation-api';
import { changePage  } from 'store/client/slice.measurement-report-list-filter';
import { showErrorNotification } from "actions/action-complete-notificator";

const MeasurementReportList = () => {
	const dispatch = useDispatch();
	const params = useParams();
	const clientIdString = params.id;

	const measurementReportListFilter = useSelector(state => state.measurementReportListFilter);
	const { data: measurementReportList } = useGetMeasurementReportsQuery(measurementReportListFilter, { refetchOnMountOrArgChange: true });
	const [ downloadMeasurementReportsAction ] = useDownloadMeasurementReportsMutation();
	const translations = useSelector(translationApi.endpoints.getTranslations.select()).data ?? {};

	const changeMeasurementReportListPage = (filterChange) => {
        dispatch(changePage(filterChange.page));
	}

	const downloadReport = async (measurementReport) => {
		const result = await downloadMeasurementReportsAction(measurementReport);
		if ('error' in result) {
			showErrorNotification(result.error);
		}
	}

	const getPageHeader = () => {
		let title = translations.measurementReportList;
		const breadcrumbsCurrentPage = translations.measurementReportList;
		const buttons = [];
		let breadcrumbs = [];
		if (clientIdString && measurementReportList?.clientName) {
			title = `${measurementReportList.clientName} - ${translations.measurementReportList}`;
			breadcrumbs = [
				{ name: `${translations.client} ${measurementReportList.clientName}`, link: PATH_CLIENT_EDIT + clientIdString }
			]
		}

		return <PageHeader title={title} buttons={buttons} breadcrumbs={breadcrumbs} breadcrumbsCurrentPage={breadcrumbsCurrentPage} />
	}

	const pageHeader = getPageHeader();
	const headers = [translations.reportNumber, translations.readingDate, translations.clientNumberShort, translations.client, translations.importFileNameShort, translations.deliveryAddress, translations.actions];
	let rows = [];
	if (measurementReportList && measurementReportList.measurementReports) {
		rows = measurementReportList.measurementReports.map(function (report) {
			return {
				columns: [
					report.clientDosemeterMeasurementReportNumber,
					report.clientDosemeterMeasurementResultReadingDate.slice(0,10),
					report.clientId?.toString().padStart(4, '0'),
					truncate(report.clientName, 30),
					report.measurementFileName,
					`${report.deliveryAddressStreet}, ${report.deliveryAddressPostalCode} ${report.deliveryAddressCity}`
				],
				tooltips: [null, null, report.clientName, null, null, null],
				buttons: [
					<button type="button" key={"download" + report.clientDosemeterMeasurementReportId} onClick={async () => {await downloadReport(report)}} className="btn btn-sm btn-gray-800 p-1 me-2" >{translations.actionDownload}</button>
				]
			}
		}, this);
	}

	return (
		<div>
			{pageHeader}
			<ClientMeasurementReportSearchFilter />
			<Table fetchList={changeMeasurementReportListPage} headers={headers} rows={rows} pagination={measurementReportList?.pagination} translations={translations} />
		</div>
	);
}

export default MeasurementReportList;
